import { fustionColorPalette } from "../constant/fusion-color-pallete";

const palette = fustionColorPalette;

export const parseColor = (color: string) => {
  if (!color) {
    return "";
  }
  if (palette?.[color]) {
    return palette[color];
  }
  if (
    color.startsWith("#") ||
    ["rgb", "hsl", "transparent", "none"].some(other => color.toLowerCase().includes(other))
  ) {
    return color;
  }
  return "";
};

export default parseColor;
